var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sensitive_header"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("敏感内容文档#!!!#src/pages/H5/Cloud/components/header/sensitiveBlockedHeader.vue_1")))]),_vm._t("avatar")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }